import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Grid, makeStyles } from '@material-ui/core'

import { Header, Typography } from '~/components'
import { useTenantConfigQuery } from '~/utils/useTenantConfigQuery'
import { storedToken } from '~/utils'
import { secureCache } from '~/utils/secureCache'
import { NO_MEMBER_ID } from './utils'

import INELIGIABLE_STATE_IMAGE from '~/screens/signup/assets/ineligible_insurance.png'

const AccountIneligibleInsurance: React.FC = () => {
  const history = useHistory<{ title: string; body: string; key: string }>()
  const tenantData = useTenantConfigQuery().data
  const signupFormImage = tenantData?.signupFormImage
  const classes = useStyles()
  useEffect(() => {
    storedToken.remove()
    secureCache.clear()
  }, [])
  return (
    <>
      <Header />
      <Container>
        <Grid container spacing={2} className={classes.outerGrid}>
          <Grid md={6} item container direction="column" justifyContent="center">
            <Typography variant="heading-03">{history.location?.state?.title}</Typography>
            {history.location?.state?.key && history.location?.state?.key === NO_MEMBER_ID ? (
              <>
                <Typography variant="subText">
                  Your Firefly Member ID is a combination of letters and numbers on the front of
                  your Firefly Health insurance card or in a welcome letter mailed to the primary
                  subscriber’s address.
                </Typography>
                <br />
                <Typography variant="subText">
                  If you’ve lost or not yet received your Firefly Health insurance card and believe
                  you should have, please call us at (888) 897-1887 between 7am and 7pm EST and
                  we’ll be happy to assist you.
                </Typography>
              </>
            ) : (
              <Typography variant="subText">
                We accept most insurance plans. Visit{' '}
                <a href="https://fireflyhealth.com/care">fireflyhealth.com/care</a> to learn more.
              </Typography>
            )}
          </Grid>
          <Grid
            md={6}
            item
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <img
              className={classes.image}
              src={signupFormImage || INELIGIABLE_STATE_IMAGE}
              alt="Firefly Health App"
            />
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
const useStyles = makeStyles(theme => ({
  image: {
    display: 'block',
    maxHeight: '815px',
    width: '400px',
  },
  outerGrid: {
    padding: 10,
  },
}))

export default AccountIneligibleInsurance
